import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { IPreferencesService } from 'vscode/vscode/vs/workbench/services/preferences/common/preferences.service';
import { PreferencesService } from './vscode/src/vs/workbench/services/preferences/browser/preferencesService.js';
import { IPreferencesSearchService } from 'vscode/vscode/vs/workbench/contrib/preferences/common/preferences.service';
import { PreferencesSearchService } from './vscode/src/vs/workbench/contrib/preferences/browser/preferencesSearch.js';
import { KeybindingsEditingService } from './vscode/src/vs/workbench/services/keybinding/common/keybindingEditing.js';
import { IKeybindingEditingService } from 'vscode/vscode/vs/workbench/services/keybinding/common/keybindingEditing.service';
import './vscode/src/vs/workbench/contrib/preferences/browser/preferences.contribution.js';

function getServiceOverride() {
    return {
        [( IPreferencesService.toString())]: new SyncDescriptor(PreferencesService, [], true),
        [( IPreferencesSearchService.toString())]: new SyncDescriptor(PreferencesSearchService, [], true),
        [( IKeybindingEditingService.toString())]: new SyncDescriptor(KeybindingsEditingService, [], true)
    };
}

export { getServiceOverride as default };
